export default __webpack_public_path__ + "static/femme-cercle2x-257d69d248380a2f11eb8fe1c0bf3a88.png";